import React, { useEffect } from 'react';
import styles from './index.module.scss';
import Button from '../../components/Button';
import { useAuth } from '../../../hooks/auth';
import { useHistory } from 'react-router-dom';
import { analyticsApi } from '../../../services/analytics';

const Welcome = () => {
  const auth = useAuth();
  const history = useHistory();

  useEffect(() => {
    analyticsApi.logEvent(
      '',
      'View',
      {},
      'Welcome'
    );
  }, []);

  useEffect(() => {
    if (auth.isAuthenticated && !auth.isLoading) {
      window.location.href = '/tracker';
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  if(auth.isAuthenticated || auth.isLoading) {
    return null
  }

  return (
    <>
      <div className={styles.body}>
        <h1 className={`scene_title`}>Your Personal Track</h1>
        <img
          src="/assets/images/welcome.png"
          alt=""
          className={styles.welcome_image}
        />
        <div className={styles.button_wrapper}>
          <Button
            type={'default'}
            onClick={() => {
              analyticsApi.logEvent(
                '',
                'Action',
                { page: 'Welcome' },
                'Sign Up Clicked'
              );
              history.push('/signup');
            }}
          >
            Sign Up
          </Button>
          <Button
            type={'default_transparent'}
            onClick={() => {
              analyticsApi.logEvent(
                '',
                'Action',
                { page: 'Welcome' },
                'Sign In Clicked'
              );
              history.push('/signin');
            }}
          >
            Sign In
          </Button>
        </div>
      </div>
      <div className={styles.footer}>
        By continuing you agree to our <br />
        <a href="">Terms of Service</a> | <a href="">Privacy Policy</a> |{' '}
        <a href="">Money Back Policy</a> <br />
        2021. All rights reserved.
      </div>
    </>
  );
};

export default Welcome;
